var iban = require('iban');
var _require = require('../../utils/regex'),
  NON_DIGITS_REGEX = _require.NON_DIGITS_REGEX;
var _require2 = require('./constants'),
  INVALID = _require2.INVALID,
  VALID = _require2.VALID;
var FINNISH_BIC_CODES = require('./bank-codes/fi');
var FINNISH_IBAN_LENGTH = 16;
var getBicFromIBAN = function getBicFromIBAN(sanitizedIban) {
  // first 4 characters are country code and checksum
  var bankAccountNumber = sanitizedIban.substring(4, sanitizedIban.length);
  var monetaryCodeFirstDigit = bankAccountNumber[0];
  var monetaryCodeLength;
  if (monetaryCodeFirstDigit === '3') {
    monetaryCodeLength = 2;
  } else if (monetaryCodeFirstDigit === '4' || monetaryCodeFirstDigit === '7') {
    monetaryCodeLength = 3;
  } else {
    monetaryCodeLength = 1;
  }
  var monetaryInstitutionCode = bankAccountNumber.substring(0, monetaryCodeLength);
  return FINNISH_BIC_CODES[monetaryInstitutionCode];
};
var parse = function parse(bankAccount) {
  var result = {
    valid: INVALID,
    bankAccount: '',
    bic: '',
    formatted: '',
    error: {
      type: 'genericError',
      message: "Invalid bank account: ".concat(bankAccount)
    }
  };
  if (typeof bankAccount !== 'string') {
    return result;
  }
  var bankAccountCleaned = bankAccount.replace(/\s/g, '').toUpperCase();
  var digits = bankAccountCleaned.replace(NON_DIGITS_REGEX, '');
  if (digits.length !== FINNISH_IBAN_LENGTH) {
    result.error.type = 'length';
    result.error.message = "Invalid bank account length: ".concat(bankAccount);
    return result;
  }
  var sanitized = "FI".concat(digits);
  result.bankAccount = sanitized;
  result.valid = iban.isValid(sanitized) ? VALID : INVALID;
  if (result.valid === INVALID) {
    return result;
  }
  var bic = getBicFromIBAN(sanitized);
  if (bic === undefined) {
    result.valid = INVALID;
    return result;
  }
  result.bic = bic;
  result.formatted = result.bankAccount;
  result.error.type = null;
  result.error.message = null;
  return result;
};
module.exports = {
  parse: parse
};